enum MediaState {
    muteAudio = 1,
    muteVideo = 2,
    switchCamera = 3,
    unmuteAudio = 4,
    unmuteVideo = 5
}

export default MediaState;